import type { RouterI18nParameters, RouterLocale } from "@/locales/fr/router";

import { ERouteName } from "@/routeName";

const router: RouterLocale = {
  [ERouteName.LOGIN]: "Login",
  [ERouteName.DASHBOARD]: "Dashboard",
  [ERouteName.SITE_SEARCH]: "Search sites",
  [ERouteName.SITE_CREATE]: "Create a site",
  [ERouteName.SITE_DETAILS]: "Overview",
  [ERouteName.SITE_DETAILS_OVERVIEW]: "Overview",
  [ERouteName.SITE_DETAILS_GALLERY]: "Gallery",
  [ERouteName.SITE_DETAILS_DOCUMENTS]: "Documents",
  [ERouteName.SITE_DETAILS_SUPPORT]: "Support",
  [ERouteName.SITE_DETAILS_ROTATION]: "Relocation",
  [ERouteName.SITE_DETAILS_LIVE_VX]: "Steering Monitoring",
  [ERouteName.SITE_DETAILS_DTD]: "DTD",
  [ERouteName.SITE_DETAILS_OPERATION]: "Operation",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_MODULATIONS]: "Modulations",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_ACQUISITION]: "Acquisition",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_FEEDBACK]: "Subscriber feedback",
  [ERouteName.SITE_DETAILS_SENSORS]: "Temperature sensors",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_EDIT]: "Edit subscriber",
  [ERouteName.SITE_DETAILS_SITE_EDIT]: "Edit site",
  [ERouteName.SITE_DETAILS_APPOINTMENT]: "Appointment",
  [ERouteName.SITE_DETAILS_DELIVERY_POINT]: "MPAN",
  [ERouteName.SITE_DETAILS_CLOSE_CALL]: "Close call",
  [ERouteName.SITE_DETAILS_ATTACH_SUBSCRIBER]: "Attach subscriber",
  [ERouteName.SITE_DETAILS_COMFORT]: "Comfort issues",
  [ERouteName.SITE_DETAILS_CONSUMPTION]: "Consumption",
  [ERouteName.SITE_DETAILS_OFFERS_ELIGIBILITY]: "Offer Eligibility",
  [ERouteName.SITE_DETAILS_ELIGIBILITY_FORM]: "Site eligibility",
  [ERouteName.SITE_DETAILS_ESC_FODLER]: "CEE File",
  [ERouteName.V4H_ORGANIZATION_OVERVIEW]: "Overview",
  [ERouteName.V4H_ORGANIZATION_SUPPORT]: "Support",
  [ERouteName.V4H_ORGANIZATION_PILOT_OVERSIGHT]: "Piloting Oversight",
  [ERouteName.V4H_SITES_SEARCH]: "Accommodation Sites",
  [ERouteName.V4H_ORGANIZATION_DETAILS]: "Organization Sites",
};

const titles: RouterLocale = {
  [ERouteName.LOGIN]: "Login",
  [ERouteName.DASHBOARD]: "Dashboard",
  [ERouteName.SITE_SEARCH]: "Search sites",
  [ERouteName.SITE_CREATE]: "Create a site",
  [ERouteName.SITE_DETAILS]: "Overview",
  [ERouteName.SITE_DETAILS_OVERVIEW]: "Overview",
  [ERouteName.SITE_DETAILS_GALLERY]: "Gallery",
  [ERouteName.SITE_DETAILS_DOCUMENTS]: "Documents",
  [ERouteName.SITE_DETAILS_SUPPORT]: "Support",
  [ERouteName.SITE_DETAILS_ROTATION]: "Relocation",
  [ERouteName.SITE_DETAILS_LIVE_VX]: "Steering Monitoring",
  [ERouteName.SITE_DETAILS_DTD]: "DTD",
  [ERouteName.SITE_DETAILS_OPERATION]: "Operation",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_MODULATIONS]: "Modulations",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_ACQUISITION]: "Acquisition",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_FEEDBACK]: "Subscriber feedback",
  [ERouteName.SITE_DETAILS_SENSORS]: "Temperature sensors",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_EDIT]: "Edit subscriber",
  [ERouteName.SITE_DETAILS_SITE_EDIT]: "Edit site",
  [ERouteName.SITE_DETAILS_APPOINTMENT]: "Appointment",
  [ERouteName.SITE_DETAILS_DELIVERY_POINT]: "MPAN",
  [ERouteName.SITE_DETAILS_CLOSE_CALL]: "Close call",
  [ERouteName.SITE_DETAILS_ATTACH_SUBSCRIBER]: "Attach subscriber",
  [ERouteName.SITE_DETAILS_COMFORT]: "Comfort issues",
  [ERouteName.SITE_DETAILS_CONSUMPTION]: "Consumption",
  [ERouteName.SITE_DETAILS_OFFERS_ELIGIBILITY]: "Offer Eligibility",
  [ERouteName.SITE_DETAILS_ELIGIBILITY_FORM]: "Site eligibility",
  [ERouteName.SITE_DETAILS_ESC_FODLER]: "CEE File",
  [ERouteName.V4H_ORGANIZATION_OVERVIEW]: "Overview",
  [ERouteName.V4H_ORGANIZATION_SUPPORT]: "Support",
  [ERouteName.V4H_ORGANIZATION_PILOT_OVERSIGHT]: "Piloting Oversight",
  [ERouteName.V4H_SITES_SEARCH]: "Accommodation Sites",
  [ERouteName.V4H_ORGANIZATION_DETAILS]: "Organization Sites",
};

const parameters: RouterI18nParameters = {
  siteId: "Site {siteId}",
  organizationId: "Organization {organizationId}",
};

export default {
  router,
  routing: { titles, parameters },
};
